<template>
  <PassportStampVideo />
</template>

<style scoped lang="scss">
video {
  pointer-events: none;
  z-index: 0;
}

@media (min-width: 851px) {
  video {
    margin-bottom: -180px;
    margin-top: -180px;
  }
}

@media (min-width: 851px) and (max-width: 1200px ) {
  video {
    right: calc(-1 * var(--space-2));
  }
}

@media (max-width: 850px) {
  video {
    width: 100%;
    margin: calc(-1 * (var(--space-7))) auto calc(-1 * (var(--space-8)));
  }
}
</style>